export default "__VITE_ASSET__DsE54SYH__"